export const actionTypes = {
  DISPLAY_DIALOG: 'DISPLAY_DIALOG',
  DISPLAY_DIALOG_V2: 'DISPLAY_DIALOG_V2',
};

export const displayDialog = ({ limitedFeature, notificationDialog }) => ({
  type: actionTypes.DISPLAY_DIALOG,
  limitedFeature,
  notificationDialog,
});

export const displayDialogV2 = ({ notificationDialogV2 }) => ({
  type: actionTypes.DISPLAY_DIALOG_V2,
  notificationDialogV2,
});
